<div class="table-responsive table-bottom-spacer">
  <table class="table tr-table">
    <thead>
      <th scope="col">{{ resourceSettings.label || 'Resource' }}</th>
      <th scope="col">{{ serviceSettings.label || 'Services' }}</th>
      <th scope="col">Capacity</th>
      <th scope="col">Status</th>
      <th scope="col">Actions</th>
      <th scope="col">Re-order</th>
    </thead>
    <tbody>
      <ng-container *ngFor="let resource of resources; index as i; trackBy: trackBy">
        <tr class="table-info" *ngIf="showCategories && resources[i - 1]?.category !== resource.category">
          <td colspan="3">
            <span class="subhead">{{ resource.category || 'Not assigned to category' }}</span>
          </td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>
            <span class="lead">{{ resource.name }}</span>
            <span *ngIf="resource.description"><br/>{{ resource.description }}</span>
            <span *ngIf="resource.availability.waitlist && !resource.availability.reservations"><br/>Waitlist only</span>
            <span *ngIf="!resource.availability.waitlist && resource.availability.reservations"><br/>{{ reservationsLabel | titlecase }} only</span>
          </td>
          <td>
            {{ getServiceNames(resource.services) }}
          </td>
          <td>
            {{ resource.capacity.min }} - {{ resource.capacity.max }}
          </td>
          <td>
            <div class="form-group">
              <tablesready-switcher
                id="switch-{{i}}"
                [(ngModel)]="resource.enabled"
                (ngModelChange)="toggleEnabled(resource)"
              ></tablesready-switcher>
            </div>
          </td>
          <td>
            <div class="d-flex">
              <button class="btn btn-info btn-icon"
                      (click)="addEditResource(resource)"
                      angularticsCategory="settings"
                      angulartics2On="click"
                      angularticsAction="Edit Resource">
                <tr-icon [icon]="icon.edit" [white]="true"></tr-icon>
              </button>
              <button class="btn btn-danger ml-2"
                      (click)="deleteResource(resource)"
                      angularticsCategory="settings"
                      angulartics2On="click"
                      angularticsAction="Delete Resource">
                <tr-icon [icon]="icon.delete" [white]="true" ></tr-icon>
              </button>
            </div>
          </td>
          <td>
            <div class="btn-group p-0 d-flex order" role="group" aria-label="Arrows to change service order">
              <button class="btn btn-info"
                      (click)="move(i, -i)"
                      [disabled]="i === 0 || isReorder"
                      angularticsCategory="settings"
                      angulartics2On="click"
                      angularticsAction="Move Service Top">
                <i class="bi bi-arrow-bar-up"></i>
              </button>
              <button class="btn btn-info"
                      (click)="move(i, -1)"
                      [disabled]="i === 0 || isReorder"
                      angularticsCategory="settings"
                      angulartics2On="click"
                      angularticsAction="Move Service Up">
                <i class="bi-arrow-up"></i>
              </button>
              <button class="btn btn-info"
                      (click)="move(i, 1)"
                      [disabled]="i === resources.length-1 || isReorder"
                      angularticsCategory="settings"
                      angulartics2On="click"
                      angularticsAction="Move Service Down">
                <i class="bi bi-arrow-down"></i>
              </button>
              <button class="btn btn-info"
                      (click)="move(i, resources.length-i-1)"
                      [disabled]="i === resources.length-1 || isReorder"
                      angularticsCategory="settings"
                      angulartics2On="click"
                      angularticsAction="Move Service Bottom">
                <i class="bi-arrow-bar-down"></i>
              </button>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
